/* eslint-disable */
import { createContext, useEffect } from "react";

import { RouterProvider, createBrowserRouter } from "react-router-dom";

import Login from "./screens/login/Login";
import { ActivateOffer } from "./screens/product/ActivateOffer";
import { HomePage } from "./screens/product/HomePage";
import { ProductList } from "./screens/product/ProductList";
import { useAppDispatch, useAppSelector } from "./store/store";
import { lngLocalization, loadLanguageConfig } from "./store/appSlice";
import TfaVerify from "./screens/login/TfaVerify";
import { ProtectedRoute } from "./components/common/ProtectedRoute";
import { keepLogged, logout } from "./store/authSlice";
import { PolicyList } from "./screens/policy/PolicyList";
import { PolicyInstallmentList } from "./screens/policy/PolicyInstallmentList";
import ForgotPassword from "./screens/login/ForgotPassword";
import ConfirmNewPassword from "./screens/login/ConfirmNewPassword";
import { LngLocalization } from "./language/localization";
import { ClaimList } from "./screens/claim/ClaimList";
import SubmitClaim from "./screens/claim/SubmitClaim";
import Profile from "./screens/profile/Profile";
import Faq from "./screens/Faq";
import { PolicyCancellation } from "./screens/policy/PolicyCancellation";
import ActivateAccount from "./screens/profile/ActivateAccount";
import { Layout } from "./layout/Layout";
import Broker from "./screens/profile/Broker";
import { OrderOfBeneficiaries } from "./screens/policy/OrderOfBeneficiaries";

// https://stackoverflow.com/a/61336826/3049911
export const LocalizationContext = createContext<LngLocalization>({} as LngLocalization);

function App() {
  const actionDispatch = useAppDispatch();
  const localization = useAppSelector((state) => lngLocalization(state));
  const appRoutes = createBrowserRouter([
    {
       path: "login/:bankKey?/:lang?",
      element: <Login />,
      caseSensitive: false,
    },
    {
      path: "tfaVerify",
      element: <TfaVerify />,
      caseSensitive: false,
    },
    {
      path: "forgot-password",
      element: <ForgotPassword />,
      caseSensitive: false,
    },
    {
        path: "confirmNewPassword/:code/:bankKey?/:lang?",
      element: <ConfirmNewPassword />,
      caseSensitive: false,
    },
    {
      path: "resetPassword/:code/:bankKey?/:lang?",
      element: <ConfirmNewPassword />,
      caseSensitive: false,
    },
    {
      path: "/",
      element: <ProtectedRoute />,
      errorElement: (
        <Layout>
          <div className="h-full flex flex-col gap-2 justify-center items-center">
            <h1>Route not found</h1>
            <span className="text-center text-base">
              Should be fixed, app should not land on this page.
            </span>
          </div>
        </Layout>
      ),
      children: [
        {
          path: "",
          element: <HomePage />,
        },
        {
          path: "/products",
          children: [
            {
              path: "",
              element: <ProductList />,
            },
            {
              caseSensitive: false,
              path: "activate-offer/:id",
              element: <ActivateOffer />,
            },
          ],
        },
        {
          path: "/claim",
          children: [
            {
              path: "",
              element: <ClaimList />,
            },
            {
              path: "submit",
              element: <SubmitClaim />,
            },
          ],
        },
        {
          path: "/insurance",
          children: [
            {
              path: "",
              element: <PolicyList />,
            },
            {
              caseSensitive: false,
              path: "installments",
              element: <PolicyInstallmentList />,
            },
            {
              caseSensitive: false,
              path: "cancel",
              element: <PolicyCancellation />,
            },
            {
              caseSensitive: false,
              path: "order-of-beneficiaries",
              element: <OrderOfBeneficiaries />
            }
          ],
        },
        {
          path: "profile",
          element: <Profile />,
        },
        {
          path: "broker",
          element: <Broker />
        },
        {
          path: "broker/:infoCode",
          element: <Broker />
        },
        {
          path: "activate-account",
          element: <ActivateAccount />,
        },
        {
          path: "faq",
          element: <Faq />,
        },
      ],
    },
  ]);

  useEffect(() => {
    actionDispatch(loadLanguageConfig());

    //Retrieve palAuth token anc check throught Token controller is this ok. Also add this to the private route access
    const loggedInUser = sessionStorage.getItem("palAuth");
    if (loggedInUser) {
      actionDispatch(keepLogged());
    } else {
      actionDispatch(logout());
    }

    if (localStorage["policiesAmended"]) {
      try
      {
        const processingPolicies = JSON.parse(localStorage["policiesAmended"]) as {time: Date, policies: number[]};
        const diff = (new Date()).getTime() - processingPolicies.time.getTime();
        const seconds = Math.floor(diff / 1000 % 60);
        if (seconds > 30)
          localStorage.removeItem("policiesAmended");
        else
          setTimeout(() => {
            if (localStorage["policiesAmended"])
              localStorage.removeItem("policiesAmended");
          }, 15000);
      }
      catch(err)
      {}
    }
  }, []);

  if (!localization) return null;

  return (
    <LocalizationContext.Provider value={localization}>
      <div className="app h-full">
        <RouterProvider router={appRoutes} fallbackElement={<div>Could not find the route</div>} />
      </div>
    </LocalizationContext.Provider>
  );
}

export default App;
